{
  "version": 1,
  "asset_id": "1ccd4d01-f416-4333-a873-cbafe9101636",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/1ccd4d01-f416-4333-a873-cbafe9101636/raindrop-certified-installer.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/1ccd4d01-f416-4333-a873-cbafe9101636/raindrop-certified-installer.webp",
  "original_filename": "raindrop-certified-installer.webp",
  "size": 47654,
  "content_type": "image/webp",
  "created_at": "2026-08-16T22:26:18Z"
}
